import * as _ from "lodash";
import { useState } from "react";
import { IEwtSummary, ITargetItem } from "@nkr/models/index";
import { Panel, Button } from "react-bootstrap";
import { ListType } from '@nkr/views/target-new/list-type';
import PatientGrid from '@nkr/views/target-new/patient-grid';
import { GridReadyEvent } from "ag-grid-community";

interface IProps {
    list: ITargetItem[],
    cutoff: number,
    onShowEwt: (summary: IEwtSummary, initialCount: any) => void,
    onShowFwt: (recipient: ITargetItem) => void,
    onShowMortalityBreakdown: (type: number, recipient: ITargetItem) => void,
    onGridReady: (e: GridReadyEvent) => void
}

const PairedPatients = (props: IProps) => {
    const [toggle, setToggle] = useState(false);

    const getPairs = () => {
        let sortedRows = _.sortBy(props.list, x => x.majorSort);

        let filteredList = sortedRows.filter(x => {
            let toggleFilter = toggle ? x.withinTwoWeeks : true;
            return toggleFilter;
        })

        return filteredList;
    }

    const list = getPairs();

    return (
        <>
            <Panel>
                <Panel.Heading style={{ padding: "2px 4px", fontWeight: 600 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 16 }}><strong>Pairs: Not Matched, Unfavorable ABO, excluding Hard to Match</strong></span>
                    </div>
                </Panel.Heading>

                <Panel.Body style={{ padding: "2px 4px" }}>
                    <PatientGrid
                        list={list}
                        type={ListType.PairedPatients}
                        fullSize={true}
                        showTargetColumn={false}
                        showEwtModel={true}
                        showFwtModel={true}
                        suppressed={false}
                        forceAutoHeight={list.length == 0}
                        noRowsText='No high risk paired patients found...'
                        useRowClass={true}
                        isHighDeclines={true}
                        onGridReady={props.onGridReady}
                        onShowEwt={props.onShowEwt}
                        onShowFwt={props.onShowFwt}
                        onShowMortalityBreakdown={props.onShowMortalityBreakdown}
                    />
                </Panel.Body>
            </Panel>
        </>
    );
}

export default PairedPatients;